import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 29,
  height = 31,
  className = "",
  viewBox = "0 0 29 31",
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M26.3991 5.40331L15.148 0.715357C14.8052 0.573182 14.4378 0.5 14.0668 0.5C13.6958 0.5 13.3284 0.573182 12.9856 0.715357L1.73454 5.40331C0.685614 5.83695 0 6.86244 0 7.99927C0 19.6313 6.70964 27.6711 12.9798 30.2846C13.6713 30.5718 14.4506 30.5718 15.1421 30.2846C20.1641 28.1926 28.1277 20.9673 28.1277 7.99927C28.1277 6.86244 27.4421 5.83695 26.3991 5.40331ZM14.4272 28.556C14.1928 28.6497 13.935 28.6497 13.7064 28.556C7.96953 26.2823 1.87518 18.3128 1.87518 7.99927C1.87518 7.61837 2.10372 7.2785 2.44946 7.132L13.7006 2.44404C13.9291 2.35028 14.1928 2.35028 14.4213 2.44404L25.6724 7.132C26.024 7.2785 26.2526 7.61837 26.2467 7.99927C26.2526 18.3128 20.1582 26.2823 14.4272 28.556ZM14.0639 24.5829V6.35849L5.70173 9.84515C6.29358 16.8829 10.2197 22.444 14.0639 24.5829ZM12.1887 20.6685C10.0557 18.3304 8.33284 14.9374 7.72927 11.0289L12.1887 9.17126V20.6685Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
